import React from "react";
import Styles from "./styles.module.scss";
export const GradientButton = ({ variant, children, className, ...props }) => {
	return (
		<button {...props} className={`${Styles.gradientbtn} ${className}`}>
			{children}
		</button>
	);
};
